import { apiClient } from '@/shared/api/client';
import type { ApiResponse } from '@/shared/types/api.types';
import type {
  Education,
  CreateEducationRequest,
  UpdateEducationRequest,
} from '@/features/educations/types/education.types';

const AUTH_BASE = '/candidate/educations';
function publicBase(shareId: string): string {
  return `/public/candidates/${shareId}/educations`;
}

export const candidateEducationService = {
  list: async (): Promise<Education[]> =>
    (await apiClient<ApiResponse<Education[]>>(AUTH_BASE, { method: 'GET' })).data,

  create: async (request: CreateEducationRequest): Promise<Education> =>
    (await apiClient<ApiResponse<Education>>(AUTH_BASE, { method: 'POST', body: request })).data,

  update: async (id: string, request: UpdateEducationRequest): Promise<Education> =>
    (
      await apiClient<ApiResponse<Education>>(`${AUTH_BASE}/${id}`, {
        method: 'PUT',
        body: request,
      })
    ).data,

  delete: async (id: string): Promise<void> => {
    await apiClient(`${AUTH_BASE}/${id}`, { method: 'DELETE' });
  },

  listByShareId: async (shareId: string): Promise<Education[]> =>
    (await apiClient<ApiResponse<Education[]>>(publicBase(shareId), { method: 'GET' })).data,

  createByShareId: async (shareId: string, request: CreateEducationRequest): Promise<Education> =>
    (
      await apiClient<ApiResponse<Education>>(publicBase(shareId), {
        method: 'POST',
        body: request,
      })
    ).data,

  updateByShareId: async (
    shareId: string,
    id: string,
    request: UpdateEducationRequest
  ): Promise<Education> =>
    (
      await apiClient<ApiResponse<Education>>(`${publicBase(shareId)}/${id}`, {
        method: 'PUT',
        body: request,
      })
    ).data,

  deleteByShareId: async (shareId: string, id: string): Promise<void> => {
    await apiClient(`${publicBase(shareId)}/${id}`, { method: 'DELETE' });
  },
};
